import { api } from '@/api'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import DetailPageHead from '@/components/DetailPageHead/index.tsx'
import SuccessStories from '@/components/SuccessStories'
import { usePage } from '@/hooks'
import { SuccessStory } from '@/interfaces/SuccessStory'
import React, { useEffect, useState } from 'react'

const SuccessStoryDetail = (): React.ReactElement => {
  const [story, setStory] = useState<SuccessStory | undefined>()

  const page = usePage()

  const { object, global } = page.init_state
  const { config } = global

  useEffect(() => {
    api
      .getSuccessStory({ id: object.id })
      .then((data) => {
        setStory(data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [object.id])

  return (
    <>
      <Container>
        <BackLink href={config.live_like_a_host} title='Живи как хозяин' />

        {story !== undefined
          ? (
            <DetailPageHead
              image={story.detail_picture}
              date={story.date_create}
              title={story.name}
              content={story.detail_text}
            />
            )
          : null}
      </Container>

      <SuccessStories />
    </>
  )
}

export default SuccessStoryDetail
